import * as React from 'react';
import { ContainerContext, mapProps } from './index';
import {
    BaseContainer,
    BaseElement,
    CreateEconomyStoreItemComponent,
} from '../components';
import actions from '../actions';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { PaidOutlined as PaidIcon } from '@mui/icons-material';
import { StateMap } from '../reducers';
import { RecurringResetTimerType, TimerType } from '../enums';
import useMediaQuery from '@mui/material/useMediaQuery';

interface Props extends ContainerContext.Props {
    readonly items: Entities.EconomyItem[];
    readonly segments: Entities.Segment[];
    readonly currencies: Entities.Currency[];
}

class Container extends BaseElement<Props> {

    async componentDidMount() {
        await actions.economy.getCreateStoreData();
    }

    protected renderContainer(): React.JSX.Element {
        const headlines = [
            {
                text: 'Store',
                to: `/economy/store`,
            },
            {
                text: 'Create',
            },
        ];
        return (
            <BaseContainer
                {...this.props}
                title = {"Create Economy Store Item"}
                TitleIcon = {PaidIcon}
                headlines = {headlines}
            >
                {this.renderContent()}
            </BaseContainer>
        );
    }

    private renderContent = () => {
        const { app, items, segments, currencies } = this.props;
        const { themeMode } = app;

        return (
            <CreateEconomyStoreItemComponent
                styled={this.props.styled}
                type={'Create'}
                onCreate={this.onCreate}
                onCancel={this.toEconomyStore}
                items={items}
                segments={segments}
                currencies={currencies}
            />
        );
    }

    private onCreate = async (
        displayName: string,
        metadata: string,
        productId: string,
        purchaseLimit: number,
        segmentIds: string[],
        items: string[],
        virtualCurrencyPrices: string | null,
        startTimestamp: number | null,
        endTimestamp: number | null,
        timerType: TimerType,
        recurringResetTimerType: RecurringResetTimerType | null,
        recurringStart: number | null,
        recurringDuration: number | null,
        recurringDailyDays: number[] | null,
        recurringWeeklyDayStart: number | null,
    ) => {
        await actions.economy.createStoreItem(
            displayName,
            metadata,
            productId,
            purchaseLimit,
            segmentIds,
            items,
            virtualCurrencyPrices,
            startTimestamp,
            endTimestamp,
            timerType,
            recurringResetTimerType,
            recurringStart,
            recurringDuration,
            recurringDailyDays,
            recurringWeeklyDayStart,
        );
        this.toEconomyStore();
    };

    private toEconomyStore = () => this.toLink(`/economy/store`);
}

const mapStateToProps = (state: StateMap): Props => ({
    ...mapProps(state),
    items: state.economy.items,
    segments: state.segment.segments,
    currencies: state.economy.currencies,
});
const AppContainer = (props: Props) =>
{
    const smallUp = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const navigate = useNavigate();
    return (<Container {...props} styled={{themeMode: props.app.themeMode, smallUp}} navigate={navigate}/>);
};
export default connect(mapStateToProps)(AppContainer);
